
    import * as React from 'react';

    const Hamburger24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Hamburger_24_svg__Icons/Hamburger/24" stroke="none" strokeWidth={1} fillRule="evenodd"><g transform="translate(2.000000, 4.000000)" fillRule="nonzero" id="Hamburger_24_svg__Stroke"><polygon points="0 8 20 8 20 7 0 7" /><polygon points="0 15 20 15 20 14 0 14" /><polygon points="0 1 20 1 20 0 0 0" /></g></g></svg>
        </div>
      );
    };

    Hamburger24.displayName = 'Hamburger24';

    export default Hamburger24;
  